import React from 'react';

import { FilterPillKey, ICustomAPIFilterConfig } from '~/src/dash/components/filters/common';
import { MobileFilterIcon } from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, spacing, Text } from '~/src/dash/publicaUI';
import { IListItem, IMenuList } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';
import { LoadingState } from '~/src/dash/utils/loading-states';
import { IActiveFilters } from '~/src/dash/views/dashboards/DashboardHome/common/common';
import { DashboardFilterPills } from '~/src/dash/views/dashboards/DashboardHome/common/DashboardFilterPills';

interface IDashboardFiltersProps {
  activeFilters: IActiveFilters;
  filtersCfg: ICustomAPIFilterConfig;
  handleClearAllFilters: () => void;
  filters: Record<string, IMenuList>;
  selectedFilters: Record<string, IMenuList>;
  handleAcceptFilter: (
    key: string,
    allOptions: Record<string, IListItem>,
    selectedOptions: Record<string, IListItem>,
  ) => Promise<void>;
  orderedFilterKeys: FilterPillKey[];
  loadState: LoadingState;
  handleChangeTimezone: (
    key: string,
    allOptions: Record<string, IListItem>,
    selectedOptions: Record<string, IListItem>,
  ) => void;
  isDemandRefreshing?: boolean;
  timezone: string;
  isLive?: boolean;
  isPublicaAnalytics?: boolean;
  handleOpenFilter?: () => void;
  handleCloseFilter?: (hasChangeOccurred?: boolean) => void;
  isDemandSourceUsingBidderType?: boolean;
}

export const DashboardFilters = ({
  activeFilters,
  filters,
  filtersCfg,
  handleAcceptFilter,
  handleChangeTimezone,
  handleClearAllFilters,
  handleCloseFilter = () => null,
  handleOpenFilter = () => null,
  isDemandRefreshing,
  isLive,
  isPublicaAnalytics,
  loadState,
  orderedFilterKeys,
  selectedFilters,
  timezone,
  isDemandSourceUsingBidderType,
}: IDashboardFiltersProps) => {
  return (
    <Cols extraSmallVerticalPadding gap={spacing.extraLarge} style={{ alignItems: 'center' }}>
      <Col>
        <Cols gap={spacing.extraSmall} style={{ alignItems: 'center' }}>
          <Col displayFlex>
            <MobileFilterIcon color={publicaColors.veryDarkGray} style={{ height: '14px' }} />
          </Col>
          <Col>
            <Text small bold>
              Filters
            </Text>
          </Col>
        </Cols>
      </Col>
      <Col flex>
        <DashboardFilterPills
          activeFilters={activeFilters}
          cfg={filtersCfg}
          filters={filters}
          handleAccept={handleAcceptFilter}
          handleChangeTimezone={handleChangeTimezone}
          handleClearAll={handleClearAllFilters}
          handleCloseFilter={handleCloseFilter}
          handleOpenFilter={handleOpenFilter}
          isLive={isLive}
          isPublicaAnalytics={isPublicaAnalytics}
          loadState={loadState}
          orderedFilterKeys={orderedFilterKeys}
          selectedFilters={selectedFilters}
          isDemandRefreshing={isDemandRefreshing}
          timezone={timezone}
          isDemandSourceUsingBidderType={isDemandSourceUsingBidderType}
        />
      </Col>
    </Cols>
  );
};
